"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var Header_module_scss_1 = __importDefault(require("./Header.module.scss"));
var HeaderContacts_1 = require("../headerContacts/HeaderContacts");
var HeaderNavigation_1 = require("../headerNavigation/HeaderNavigation");
var Svg_1 = require("../svg/Svg");
var selectors_1 = require("../../redux/selectors");
var useHeaderFixed_1 = require("../../hook/useHeaderFixed");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var Header = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var burgerMenuState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).burgerMenu.modalState;
    var windowScrollPosition = (0, useHeaderFixed_1.useHeaderFixed)();
    var headerIsActive = function () {
        if (windowScrollPosition === 0 && location.pathname === '/')
            return false;
        if (location.pathname !== '/')
            return true;
        return windowScrollPosition !== 0 || burgerMenuState;
    };
    var logoIsActive = function () {
        if (burgerMenuState) {
            return true;
        }
        return false;
    };
    return (react_1.default.createElement("header", { className: "".concat(Header_module_scss_1.default.header, " ").concat(headerIsActive() ? Header_module_scss_1.default.header_active : ''), id: "header" },
        react_1.default.createElement("div", { className: "".concat(Header_module_scss_1.default.header__inner, " container") },
            react_1.default.createElement("div", { className: Header_module_scss_1.default.logo },
                react_1.default.createElement(Svg_1.Logo, { className: "".concat(logoIsActive() ? Header_module_scss_1.default.logo_active : '', " ").concat(Header_module_scss_1.default.logo__img) })),
            react_1.default.createElement("div", { className: Header_module_scss_1.default.header__info },
                react_1.default.createElement(HeaderContacts_1.HeaderContacts, null),
                react_1.default.createElement(HeaderNavigation_1.HeaderNavigation, null)))));
};
exports.Header = Header;
